import axios, { AxiosError, AxiosRequestConfig } from "axios"
import { BaseQueryFn } from "@reduxjs/toolkit/query"
import { Permission } from "../../models/permission.model"

const parseJSON = (value: string | null) => {
  try {
    return value ? JSON.parse(value) : null
  } catch {
    return null
  }
}

const refreshToken = async () => {
  try {
    const { data } = await axios.post(
      `${import.meta.env.VITE_APP_API}/auth/refresh`,
      null,
      {
        headers: {
          "x-refresh-token": localStorage.getItem("refreshToken") || "",
        },
      },
    )
    localStorage.setItem("accessToken", data?.accessToken)
  } catch (error) {
    if ((error as AxiosError).response?.status === 401) {
      localStorage.clear()
      window.location.href = `${window.location.origin}/login`
    }
    throw error
  }
}

export const axiosBaseQuery =
  ({ baseUrl }: { baseUrl?: string } = { baseUrl: "" }): BaseQueryFn =>
  async ({ url, method, data, params, permission, headers, responseType }) => {
    const permissions = parseJSON(localStorage.getItem("userRolePermissions"))
    const currentRole = parseJSON(localStorage.getItem("currentRole"))

    if (
      permission &&
      currentRole?.key !== "super_admin" &&
      !permissions?.some((perm: Permission) => perm === permission)
    ) {
      return {
        error: {
          status: 403,
          data: { message: `You don't have ${permission} permission` },
        },
      }
    }

    const config: AxiosRequestConfig = {
      url: baseUrl + url,
      method,
      data,
      params,
      responseType: responseType ?? "json",
      headers: {
        ...headers,
        Authorization: `Bearer ${localStorage.getItem("accessToken") || ""}`,
      },
    }

    try {
      const result = await axios(config)
      return { data: result.data }
    } catch (error) {
      const err = error as AxiosError

      if (err.response?.status === 401) {
        try {
          await refreshToken()
          return await axios({
            ...config,
            headers: {
              ...config.headers,
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          })
        } catch {
          return {
            error: { status: 401, data: { message: "Unauthorized" } },
          }
        }
      }

      if (err?.response?.status === 403) {
        // localStorage.clear()
        // window.location.href = `${window.location.origin}/login`
      }
      return {
        error: { status: err.response?.status, data: err.response?.data },
      }
    }
  }
